var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebookFBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7197 31.796C7.05722 31.8397 -0.0490285 24.6397 0.150972 15.8522C0.338472 7.47724 7.28222 0.53974 15.926 0.63974C24.4635 0.73974 31.5135 7.85224 31.2885 16.6397C31.076 24.9772 24.201 31.8335 15.7197 31.796ZM2.04472 16.2335C2.11347 24.0647 8.44472 30.0835 15.9322 29.971C23.1947 29.8585 29.3822 23.946 29.3885 16.221C29.3885 8.39599 23.0072 2.34599 15.501 2.47099C8.22597 2.58974 2.09472 8.51474 2.04472 16.2335Z",
    fill: "#F25C05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1428 12.8768H16.64V11.2353C16.64 10.6189 17.0486 10.4751 17.3363 10.4751C17.6234 10.4751 19.1025 10.4751 19.1025 10.4751V7.76511L16.6701 7.75562C13.9699 7.75562 13.3554 9.77684 13.3554 11.0703V12.8768H11.7938V15.6693H13.3554C13.3554 19.2531 13.3554 23.5712 13.3554 23.5712H16.64C16.64 23.5712 16.64 19.2105 16.64 15.6693H18.8563L19.1428 12.8768Z",
    fill: "#F25C05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebookFBrands);
export default __webpack_public_path__ + "static/media/footer-facebook-f-brands.780cd88d8d93b49c300d7d5189d783df.svg";
export { ForwardRef as ReactComponent };